/**
 * Константы для компонента таблицы
 */

/** Фиксированные столбцы таблицы */
export const TABLE_FIXED_COLUMS = ['select'];

/** Разделитель для поля типа "Ссылка" */
export const TABLE_LINK_SEPARATOR = ':LINK:';

/** Разделитель множественных значений в полях таблиц */
export const TABLE_MULTIPLE_SEPARATOR = ':BREAK:';
